module.exports = __webpack_public_path__ + "static/media/AI_Review_white.3e12491f.png";